const JWT_REGEX = /(^[A-Za-z0-9-_]*\.[A-Za-z0-9-_]*\.[A-Za-z0-9-_]*$)/
export const isJwt = (token: string): boolean => Boolean(token.match(JWT_REGEX))
export const getJwtExpiryMs = (payload: {exp: number}) => payload.exp * 1000 - Date.now()
export const getJwtExpiryMin = (payload: {exp: number}) => getJwtExpiryMs(payload) / 1000 / 60
